import {ChangeDetectorRef, Component, forwardRef, Input, Optional} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPasswordControlComponent),
            multi: true
        }
    ],
    selector: "fui-password-control",
    templateUrl: "./password-control.component.html",
    standalone: false
})
export class FUIPasswordControlComponent extends FUIAbstractControl {
    @Input() allowAutocomplete: boolean;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }
}
